import React from 'react';

import './DocTableHeader.scss';

interface DocTableHeaderProps {
  headers: string[];
}

export const DocTableHeader: React.FC<DocTableHeaderProps> = ({ headers = [] }) => (
  <div className="doc-table-header">
    {headers.map((hcell, index) => (
      <div className="doc-table-header__cell" key={`key-doc-table-header-row-cell-${index + 1}`}>
        {hcell}
      </div>
    ))}
  </div>
);
